<div class="maindivLogin" [style]="{'background-image': 'url(' + backgroundUrl +')'}">
  <div class="container text-center">
    <div class="row">
      <!-- <h2 style="margin: auto; margin-top: 20px; margin-bottom: 20px; text-align: center;">GRSS Calculation Agent</h2> -->
      <img style="margin: 3rem auto 0 auto;" src='{{baseUrl + "/styles/login_logo.png"}}' width="40%" height="40%">
    </div>
    @if (enableAzureLogin == false) {
      <div class="flip-card">
        <div class="flip-card-inner" style="background-color: white;">
          <div class="flip-card-front">
            <form #loginForm="ngForm" (submit)="OnLoginSubmitted(loginForm)" autocomplete="off">
              <div class="row">
                <mat-form-field>
                  <mat-label>{{'login.lblUsername' | translate}}</mat-label>
                  <input name="username" name="username" type="text" placeholder="{{'login.lblUsername' | translate}}"
                    required matInput [(ngModel)]="user.username">
                  </mat-form-field>
                </div>
                <div class="row">
                  <mat-form-field>
                    <mat-label>{{'login.lblPassword' | translate}}</mat-label>
                    <input name="password" autocomplete="off" name="password"
                      [type]="!isPasswordVisible ? 'password' : 'text'" placeholder="{{'login.lblPassword' | translate}}"
                      required matInput [(ngModel)]="user.password">
                      <mat-icon class="clickable" matSuffix
                        (click)="isPasswordVisible = !isPasswordVisible">{{!isPasswordVisible? 'visibility_off' :
                      'visibility'}}</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="row center">
                    <button mat-raised-button style="float: right;" color="primary" type="submit">{{'login.btnLogin' |
                    translate}}</button>
                    <mat-label style="cursor: pointer;margin: auto;" (click)="OnForgotClicked()">{{'login.lblForgotPass' |
                    translate}}?</mat-label>
                  </div>
                </form>
              </div>
              <div class="flip-card-back">
                <form #forgotForm="ngForm" (submit)="OnForgotSubmitted(forgotForm)">
                  <div class="row">
                    <mat-form-field>
                      <mat-label>{{'login.lblUsername' | translate}}</mat-label>
                      <input name="username" type="text" placeholder="{{'login.lblUsername' | translate}}" required matInput
                        [(ngModel)]="user.username">
                        <mat-error>{{'errRequired' | translate}}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="row center">
                      <button style="margin-right: 20px;" mat-raised-button color="primary" type="button"
                      (click)="OnBackClicked()">{{'login.btnBack' | translate}}</button>
                      <button mat-raised-button color="primary" type="submit">{{'login.btnSend' | translate}}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          }
          @if (enableAzureLogin) {
            <div class="flip-card">
              <div class="flip-card-inner" style="background-color: white;">
                <div class="flip-card-front">
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%; margin-top: -20px;">
                    <div>
                      @if (hasLoggedIn == false) {
                        <h5>Please use your Microsoft account to login.</h5>
                      }
                      @if (hasLoggedIn) {
                        <h5>Click logout button to logout from your Microsoft account.</h5>
                      }
                      @if (hasLoggedIn == false) {
                        <button mat-raised-button color="primary" (click)="onClickAzureLogin()">Login</button>
                      }
                      @if (hasLoggedIn) {
                        <button mat-raised-button color="primary" (click)="onClickAzureLogout()" >Logout</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

      </div>
